export var transformElement = function (element) { return function ($, additionalProps, mutationFunctions) {
    $(element).each(function (_, el) {
        var $el = $(el);
        mutationFunctions.forEach(function (mutator) { return mutator($el, additionalProps); });
    });
    return $;
}; };
//# sourceMappingURL=transform-element.js.map